import { csAPI } from '@/common/service/ApiList';
import ServiceExec from '@/common/utils/ServiceExec';

export default {
  async fetchCsList({ state, commit }, userNo) {
    const { page, totalPage, limit } = state.pageInfo;
    const { data } = await ServiceExec.get(csAPI.inquiry_list, {
      page,
      userNo
    });

    if (!data) return false;

    const { pageInfo, list } = data;
    commit('setPageInfo', pageInfo);
    commit('setPage', page + 1);
    commit('setTotalPage', pageInfo?.totalPage ?? 2);
    commit('setList', list ?? []);
  },

  async fetchCsInfo({ commit }, csNo) {
    const { data } = await ServiceExec.get(csAPI.detail(csNo));
    commit('setDetail', data);
    return data;
  },

  async fetchFaqList({ commit }) {
    const { data } = await ServiceExec.get(csAPI.faq_list);
    if (!data) return false;
    const { pageInfo, list } = data;
    list.forEach((item) => (item.isFold = false));
    commit('setList', list);
    return data;
  },

  async save_inquiry({ commit }, payload) {
    const { data, status } = await ServiceExec.post(
      csAPI.inquiry_save,
      payload
    );
    return status === ServiceExec.status.OK;
  }
};
